module.exports = __webpack_public_path__ + "img/N326-1-EN.4e938932.png";